import { useEffect, useState } from 'react';
import { useBikletaPointsService } from '../../../services/bikletaPoints/bikletaPointsService';
import { POI } from '../../../services/bikletaPoints/dto';
import { centerDef, PointTypes } from '../../../utils/constants';
import { useAsync } from '../../../utils/useAsync';
import { BikletaPointsMapController, UserLocationProps } from '../interfaces';

export const useMapViewController = (): BikletaPointsMapController => {
  const [focusedPoint, setFocusedPoint] = useState(null);
  const service = useBikletaPointsService();

  const [searchInput, setSearchInput] = useState(null);

  const [data, , loading, execute, refreshing, refresh] = useAsync(
    service.fetchPOIs,
    [] as any,
    true
  );

  const initViewMethod = () => {
    execute();
  };

  useEffect(() => {
    refresh(searchInput);
  }, [searchInput]);

  const mapPoints = (elements?: POI[]) =>
    elements?.map(item => {
      const typeArray = Array.isArray(item.types) ? item.types : [];
      return {
        ...item,
        type: typeArray.map(i => i.label) || 'Bikleta Point',
      };
    });

  const [userLocation, setUserLocation] = useState<UserLocationProps | null>(
    null
  );

  useEffect(() => {
    if (!userLocation) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(res =>
          setUserLocation({
            lat: res.coords.latitude,
            lng: res.coords.longitude,
          })
        );
      } else {
        setUserLocation(centerDef);
      }
    }
  }, [userLocation]);

  return {
    initView: initViewMethod,
    focusedPoint,
    setFocusedPoint,
    data: mapPoints(data) || [],
    loading,
    refresh,
    refreshing,
    setSearchInput,
    centerPoint: userLocation,
  };
};
